import { render } from "./ActivityDetailPanel.vue?vue&type=template&id=610308bc&scoped=true"
import script from "./ActivityDetailPanel.vue?vue&type=script&lang=js"
export * from "./ActivityDetailPanel.vue?vue&type=script&lang=js"

import "./ActivityDetailPanel.vue?vue&type=style&index=0&id=610308bc&lang=scss&scoped=true"
import "./ActivityDetailPanel.vue?vue&type=style&index=1&id=610308bc&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610308bc"]])

export default __exports__